import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import PasswordManagement from './PasswordManagementApp';

const App = () => (
    <Router>
        <PasswordManagement />
    </Router>
);

const container = document.getElementById('react-root');
const root = createRoot(container);

root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
